module.exports = __webpack_public_path__ + "img/icon_proj.5924d077.png";